import './filter-more.scss'

import type { Filter_FacetsFragment } from '@generated/graphql'
import React from 'react'
import IconAdd from 'src/images/svg/icon-add'

interface FilterMoreProps {
  key: string
  label: string
  useFilteredFacets?: {
    updateFilteredFacets: Filter_FacetsFragment[] | undefined
    moreFilter?: boolean
    setMoreFilter?: React.Dispatch<React.SetStateAction<boolean>>
    status?: boolean
    indexHide: number
  }
}

function FilterMore({ key, label, useFilteredFacets }: FilterMoreProps) {
  return (
    <div key={key} className="filter-filterMore">
      <button
        onClick={() =>
          useFilteredFacets?.setMoreFilter?.(!useFilteredFacets?.moreFilter)
        }
        style={{
          color: `${useFilteredFacets?.moreFilter ? '#F08769' : ''}`,
        }}
      >
        {label}
        <div className="filter-filterMore__icon">
          <IconAdd
            add={!useFilteredFacets?.moreFilter}
            stroke={useFilteredFacets?.moreFilter ? '#F08769' : '#000'}
          />
        </div>
      </button>
    </div>
  )
}

export default FilterMore
